

export class Array<T> extends globalThis.Array<T>
{
}


export namespace Array
{
    export function distinct<T>(items: T[]): T[]
    {
        return Array.from(new Set(items));
    }

    export function includesAll<T>(array: T[], items: T[]): boolean
    {
        return items.every(item => array.includes(item));
    }

    export function includesAny<T>(array: T[], items: T[]): boolean
    {
        return items.some(item => array.includes(item));
    }

    export function notNull<T>(items: (T | undefined | null)[]): T[]
    {
        return items.filter(item => item != null) as T[];
    }

    export function removeAt<T>(array: T[], index: number): T
    {
        index = (index < 0) ? array.length + index : index;
        const item = array[index];
        array.splice(index, 1);
        return item;
    }
}


declare global
{
    interface Array<T>
    {
        at(index: number): T;
    }
}


if (!globalThis.Array.prototype.at)
{
    globalThis.Array.prototype.at =
        function (this: any[], index: number): any
        {
            index = (index < 0) ? this.length + index : index;
            return this[index];
        };
}
